












import Vue from "vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

const options: any = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }, { align: [] }],
    ["link"],
    ["clean"]
];

export default Vue.extend({
    name: "rich-editor",
    components: { quillEditor },
    props: {
        value: {
            type: String
        },
        placeholder: {
            type: String,
            default: ""
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            content: this.value,
            editorOption: {
                debug: "warn",
                modules: {
                    toolbar: options
                },
                placeholder: this.placeholder,
                theme: "snow",
                readOnly: this.disabled
            },
            quill: null
        };
    },
    created() {
        if (this.disabled) {
            this.editorOption.modules.toolbar = null;
        }
    },
    methods: {
        handleReady(quill) {
            this.$nextTick(() => {
                quill.blur();
            });
        },
        handleContentChange({ quill, html, text }) {
            this.content = html;
            this.$emit("input", this.content);
            this.$emit("on-change", this.content);
        }
    },
    watch: {
        value(val) {
            this.content = val;
        }
    }
});
